/**
 * The phone panel's leave guard (LIAA service plan S3.2): a page that must not be left mid-way (an upload running)
 * registers a guard; the panel shell's "up" asks it first. Kept apart from the shell so the feature never imports
 * the shell.
 */

import { createContext, useContext } from 'react';

/** Resolves true when leaving is fine (nothing running, or the user chose to stop it). */
export type LeaveGuard = () => Promise<boolean>;

export const LeaveGuardContext = createContext<(guard: LeaveGuard | null) => void>(() => undefined);

/** Register (or clear, with null) the current page's leave guard. */
export function useSetLeaveGuard(): (guard: LeaveGuard | null) => void {
  return useContext(LeaveGuardContext);
}
